import { render, staticRenderFns } from "./resumenInversion.vue?vue&type=template&id=d3205630&scoped=true"
import script from "./resumenInversion.vue?vue&type=script&lang=js"
export * from "./resumenInversion.vue?vue&type=script&lang=js"
import style0 from "./resumenInversion.vue?vue&type=style&index=0&id=d3205630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3205630",
  null
  
)

export default component.exports